<template>
    <nav class="px-sm mt-md flex flex-col">
        <section name="root-pages" class="gap-sm flex flex-col">
            <SideMenuDropdown
                v-for="section in visibleSections"
                :key="section.category ?? section.links[0]?.to"
                :category="section.category"
                :icon="section.icon"
                :links="section.links"
            />
        </section>
    </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAdminStore } from '@/stores/admin';
import SideMenuDropdown from './misc/side-menu-dropdown.vue';
import { getVisibleAdminMenuSections } from '@/router/admin-access';

const adminStore = useAdminStore();
const visibleSections = computed(() => getVisibleAdminMenuSections(adminStore.adminRoleContext));
</script>

<style scoped>
@reference '@/assets/styles/default.css';

.router-link {
    @apply py-xs gap-sm px-sm flex items-center rounded-sm;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: var(--surface-hover);
    }

    & > i {
        /* TODO: update icon instead of this */
        filter: brightness(0);
    }
}

/* ITDEVELOP-3090: dark invert removed — see side-menu.vue. */

.route-active {
    background-color: var(--surface-hover);
}
</style>
